import { createTheme, makeStyles } from "@material-ui/core/styles";
import sentierBackground from "../images/sentierBackground.jpg";
const Theme = createTheme({
  spacing: 4,
  typography: {
    fontFamily: [
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  props: {
    MuiTypography: {
      variantMapping: {
        body1: "p",
      },
    },
  },
});

const useStyles = makeStyles((theme) => ({
  fullradio: {
    display: "Block",
    width: "100%",
    maxHeight: "80px",
    margin: "0 auto",
    boxSizing: "border-box",
  },
  photo: {
    height: 150,
    maxWidth: "80%",
    marginBottom: "10px",
  },
  themeButton: {
    marginBottom: 15,
    borderRadius: "12px",
    backgroundColor: "white",
    minHeight: "18vh",
    width: "18vh",
    flexDirection: "column",
    justifyContent: "space-around",
    lineHeight: "normal",
    fontWeight: "bold",
    textTransform: "uppercase",
    border: "2px solid white",
    "&:hover": {
      border: "2px solid red",
      backgroundColor: "white",
    },
    "&:active": {
      border: "2px solid red",
      backgroundColor: "white",
    },
    "&:focus": {
      border: "2px solid red",
      backgroundColor: "white",
    },
    "&.checked": {
      border: "2px solid red",
      backgroundColor: "white",
    },
  },
  themeButton2: {
    marginBottom: 10,
    borderRadius: "12px",
    backgroundColor: "white",
    height: 100,
    width: 100,
    flexDirection: "column",
    justifyContent: "center",
    display: "flex",
    margin: "auto",
    "&:hover": {
      border: "2px solid red",
      backgroundColor: "white",
    },
    "&:active": {
      border: "2px solid red",
      backgroundColor: "white",
    },
    "&:focus": {
      border: "2px solid red",
      backgroundColor: "white",
    },
    "&.checked": {
      border: "2px solid red",
      backgroundColor: "white",
    },
  },
  column: {
    display: "flex",
    marginBottom: 5,
    justifyContent: "center",
    flexDirection: "column",
  },
  commentBox: {
    width: "100%",
    marginTop: 10,
    background: "white",
  },
  emojisColumn: {
    display: "flex",
    flexDirection: "column",
  },
  boxButton: {
    display: "flex",
    margin: "0 auto 20px",
    maxWidth: "95%",
    justifyContent: "space-around",
    width: "100%",
  },
  gridLink: {
    width: "100%",
    height: 60,
    display: "flex",
  },
  navButton: {
    width: "180px",
    backgroundColor: "#D2D2D2",
    borderRadius: "12px",
    marginTop: 20,
    fontSize: 10,
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "#E50039",
      color: "white",
    },
  },
  navButton2: {
    width: "180px",
    backgroundColor: "#E50039",
    borderRadius: "12px",
    marginTop: 20,
    fontSize: 10,
    color: "white",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "#D2D2D2",
      color: "white",
    },
  },
  subHeader: {
    color: "white",
    backgroundImage: `url(${sentierBackground})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    height: "12vh",
    display: "flex",
    flexDirection: "column",
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 20,
    marginBottom: 20,
  },
  subHeaderTitle: {
    textAlign: "left",
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: "1.5rem",
    marginTop: 0,
    marginBottom: 0,
  },
}));

export default Theme;
export { useStyles };
